<div class="emds">
    <div [ngClass]="isOpenedAsModal ? 'modal-default modal-flex' : 'networks-grid'">
        <div
            id="{{ baseId }}-map-modal-header"
            class="modal-header"
            *ngIf="isOpenedAsModal"
        >
            <p translate>Map Provider/Plan In Network Status</p>
        </div>
        <div
            [formGroup]="form"
            [ngClass]="isOpenedAsModal ? 'modal-body' : 'networks-grid'"
        >
            <div class="flex-row-generic">
                <mat-radio-group
                    name="MapBy"
                    class="radio-group"
                    (change)="onMapBy()"
                >
                    <mat-radio-button
                        id="{{ baseId }}-map-provider"
                        value="false"
                        translate
                        [disabled]="isOpenedAsModal"
                        [checked]="isMapByProvider"
                    >Map By Provider
                    </mat-radio-button>
                    <mat-radio-button
                        id="{{ baseId }}-map-insurance-plan"
                        value="true"
                        class="radio-padding-left"
                        [checked]="!isMapByProvider"
                        translate
                    >
                        Map By Insurance Plan</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="flex-row-generic">
                <!-- Provider start -->
                <div
                    class="form-group flex-item-two-columns"
                    *ngIf="isMapByProvider"
                >
                    <label for="{{ baseId }}-to-provider-findcontrol">Select Provider</label>
                    <ap-findcontrol
                        [baseId]="baseId"
                        [form]="form"
                        [apFormGroup]="form"
                        [required]="false"
                        [disabled]="false"
                        [findControlId]="FindControlIdService.ViewProvider"
                        [singleSelect]="true"
                        [(selectedPks)]="selectedToProviderPks"
                        id="{{ baseId }}-to-provider-findcontrol"
                        controlName="providersUid"
                        findControlDisplayName="Find Provider"
                        (dirty)="toProviderUidControl.markAsDirty()"
                        (chipsChange)="onProviderDataPopulate()"
                    >
                    </ap-findcontrol>
                </div>
                <!-- Provider Control end -->

                <!-- Insurance Plan start -->
                <div
                    class="form-group flex-item-two-columns"
                    *ngIf="!isMapByProvider"
                >
                    <label for="{{ baseId }}-to-insurance-plan-findcontrol">Select Insurance Plan</label>
                    <ap-findcontrol
                        id="{{ baseId }}-to-insurance-plan-findcontrol"
                        [baseId]="baseId"
                        [apFormGroup]="form"
                        controlName="insurancePlanUidControl"
                        [findControlId]="FindControlIdService.ViewPayerPlan"
                        [(selectedPks)]="selectedInsurancePlanPks"
                        [placeHolder]=""
                        [disabled]="isOpenedAsModal"
                        [singleSelect]="true"
                        findControlDisplayName="Find Insurance Plan"
                        [required]="false"
                        (dirty)="insurancePlanUidControl.markAsDirty()"
                        [formGroupSubmitted]="isSubmitted"
                        [form]="form"
                        (chipsChange)="onInsurancePlanDataPopulate()"
                    >
                    </ap-findcontrol>
                </div>
                <!-- Insurance Plan Control end -->

                <!-- Provider start -->
                <div
                    class="form-group flex-item-two-columns"
                    *ngIf="!isMapByProvider"
                >
                    <label for="{{ baseId }}-provider-findcontrol">Map To One Or More Provider(s)</label>
                    <ap-findcontrol
                        [baseId]="baseId"
                        [form]="form"
                        [apFormGroup]="form"
                        [required]="false"
                        [disabled]="!isOpenedAsModal && (selectedInsurancePlanPks.length <= 0)"
                        [findControlId]="FindControlIdService.ViewProvider"
                        [singleSelect]="false"
                        [(selectedPks)]="selectedToProviderPks"
                        id="{{ baseId }}-provider-findcontrol"
                        controlName="providersUid"
                        findControlDisplayName="Find Provider"
                        (dirty)="toProviderUidControl.markAsDirty()"
                    >
                    </ap-findcontrol>
                </div>
                <!-- Provider Control end -->

                <!-- Insurance Plan start -->
                <div
                    class="form-group flex-item-two-columns"
                    *ngIf="isMapByProvider"
                >
                    <label for="{{ baseId }}-insurance-plan-findcontrol">Map To One Or More Insurance
                        Plan(s)</label>
                    <ap-findcontrol
                        id="{{ baseId }}-insurance-plan-findcontrol"
                        [baseId]="baseId"
                        [apFormGroup]="form"
                        controlName="insurancePlanUidControl"
                        [findControlId]="FindControlIdService.ViewPayerPlan"
                        [(selectedPks)]="selectedInsurancePlanPks"
                        [placeHolder]=""
                        [disabled]="!isOpenedAsModal && (selectedToProviderPks.length <= 0)"
                        [singleSelect]="false"
                        findControlDisplayName="Find Insurance Plan"
                        [required]="false"
                        (dirty)="insurancePlanUidControl.markAsDirty()"
                        [formGroupSubmitted]="isSubmitted"
                        [form]="form"
                    >
                    </ap-findcontrol>
                </div>
                <!-- Insurance Plan Control end -->
            </div>
            <div class="flex-right">
                <button
                    id="{{ baseId }}-clear-selected"
                    class="btn btn-light"
                    type="button"
                    (click)="onClearSelectedMappings()"
                >Clear Selected
                    Mappings</button>
                <button
                    id="{{ baseId }}-clear-all"
                    class="btn btn-light"
                    type="button"
                    (click)="onClearAllMappings()"
                    [disabled]="isOpenedAsModal"
                >Clear All
                    Mappings</button>
            </div>
        </div>
        <div class="modal-footer">
            <button
                type="submit"
                id="{{ baseId }}-save-btn"
                class="btn btn-primary"
                (click)="onSave()"
                translate
                [disabled]="disableSaveButton()"
            >
                Save
            </button>
            <button
                type="button"
                id="{{ baseId }}-cancel-btn"
                class="btn btn-secondary btn-flush-right"
                (click)="onCancel()"
                translate
            >
                Cancel
            </button>
        </div>
    </div>
</div>
